import type { Theme } from '@mui/material';

const getRibbonVariables = (theme: Theme, ribbonText: string) => {
  const defaultVariables = {
    bgColor: theme.palette.primary.cowbellBlue,
    textColor: theme.palette.common.white,
  };

  if (!ribbonText) {
    return defaultVariables;
  }

  const ribbonTextInLowerCase = ribbonText?.toLowerCase();

  if (ribbonTextInLowerCase.includes('free')) {
    return {
      bgColor: theme.palette.primary.green1,
      textColor: theme.palette.common.white,
    };
  }

  if (ribbonTextInLowerCase.includes('coming soon')) {
    return {
      bgColor: theme.palette.primary.favoriteIcon,
      textColor: theme.palette.common.white,
    };
  }

  if (ribbonTextInLowerCase.includes('popular')) {
    return {
      bgColor: theme.palette.common.yellowOrange,
      textColor: theme.palette.common.white,
    };
  }

  return defaultVariables;
};

export default getRibbonVariables;
